import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../..";
import TransmedDistributionApi from "../../../api/transmed/distribution";
import { TransmedDistributionConfirmInput } from "../../../dtos/transmed/process/process/distribution";
import { TransmedReceivingDetailWithProblems } from "../../../dtos/transmed/process/receivingDetail";

class TransmedDistributionServiceReader extends ServiceReader {
  public async mine(): Promise<TransmedReceivingDetailWithProblems[]> {
    return await new TransmedDistributionApi().get();
  }

  public async ofLc(
    lcId: string
  ): Promise<TransmedReceivingDetailWithProblems[]> {
    return await new TransmedDistributionApi().get(lcId);
  }
}

class TransmedDistributionServiceCreator extends ServiceCreator {
  public async confirmation(): Promise<void> {
    return await new TransmedDistributionApi().post();
  }
}

class TransmedDistributionServiceUpdater extends ServiceUpdater {
  public async choose(
    registrationId: number,
    lcId: string,
    accomodation: boolean
  ): Promise<void> {
    return await new TransmedDistributionApi().put(
      `${registrationId}`,
      new TransmedDistributionConfirmInput(lcId, accomodation)
    );
  }

  public async keep(
    registrationId: number,
    lcId: string,
    accomodation: boolean
  ): Promise<void> {
    return await new TransmedDistributionApi().put(
      `${registrationId}`,
      new TransmedDistributionConfirmInput(lcId, accomodation)
    );
  }
}
class TransmedDistributionServiceDeleter extends ServiceDeleter {
  public async revoke(registrationId: number): Promise<void> {
    return await new TransmedDistributionApi().delete(`${registrationId}`);
  }
}

export default class TransmedDistributionService extends Service {
  public get read(): TransmedDistributionServiceReader {
    return new TransmedDistributionServiceReader();
  }
  public get create(): TransmedDistributionServiceCreator {
    return new TransmedDistributionServiceCreator();
  }
  public get update(): TransmedDistributionServiceUpdater {
    return new TransmedDistributionServiceUpdater();
  }
  public get delete(): TransmedDistributionServiceDeleter {
    return new TransmedDistributionServiceDeleter();
  }
}
